<template>
  <div class="max-price-label">
    <img
      class="icon"
      alt="icon t"
      :src="`${$root.cdnUrl}assets/icon-t.svg`"
    >
    <div class="text">
      <div>
        {{ $t('product.components.maxPriceLabel.title') }}
      </div>
      <span>
        <b>
          {{ product.campaignStartDate | dateTime('DD.MM.YYYY') }}
          —
          {{ product.campaignEndDate | dateTime('DD.MM.YYYY') }}
          {{ $t('product.components.maxPriceLabel.betweenDate') }}
        </b>
      </span>
      <span>
        {{ $t('product.components.maxPriceLabel.maxPriceText') }}
        <b>{{ product.campaignMaxPrice | formatPrice({ suffix: '₺'}) }}</b>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MaxPriceLabel',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style scoped lang="scss">
  .max-price-label {
    padding: 8px 16px 8px 8px;
    background: #EEF4FF;
    border: 1px solid #5794FF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    ::v-deep .icon {
      width: 16px;
      height: 16px;
    }
    .text {
      margin-left: 8px !important;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
    }
  }
</style>
